import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  height: ${props => props.loadImage ? '80px' : '45px'};
  align-items: center;
  margin-bottom: 10px;
`

export const ChooseFileWrapper = styled.div`
  position: relative;
  overflow: hidden;
`

export const ChooseFileInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
`

export const ImagePreviewCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 3px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  margin-right: 10px;
  background-image: url(${props => props.backgroundImage})
`

export const FileName = styled.div`
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ErrorMessage = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 12px;
  line-height: 12px;
  color: red;
  white-space: nowrap;
`


// WEBPACK FOOTER //
// ./src/components/upload/components.js